<template>
  <textarea
    :class="{ 'form-field-error': vee ? vee.classes.failed : false }"
    class="form-input-text"
    v-bind="$props"
    v-on="{
      ...$listeners,
      input: event => $emit('input', event.target.value),
    }"
  ></textarea>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },

    name: {
      type: String,
      default: '',
    },

    value: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    rows: {
      type: Number,
      default: 5,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    vee: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
